// 一个进度条插件
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import {ElMessage} from "element-plus";

// import {registerMicroApps, addGlobalUncaughtErrorHandler, start} from "qiankun";
import { registerMicroApps, addGlobalUncaughtErrorHandler } from "qiankun";
import apps from "./apps";

/**
 * 注册子应用
 * 1. 配置子应用
 * 2. 注册子应用
 */
export function registerMicroAppsFn() {
  try {
    registerMicroApps(apps, {
      beforeLoad: (app) => {
        NProgress.start();
        return Promise.resolve();
      },
      afterMount: (app) => {
        NProgress.done()
        return Promise.resolve();
      },
      afterUnmount: () => {
        return Promise.resolve();
      },
    });
  } catch (e) {
  }
}

// registerMicroApps([...]).then((apps) => console.log(apps)); // 查看注册的应用列表和状态
// registerMicroApps(apps, {
//     beforeLoad: (app) => {
//         NProgress.start();
//         console.log("before load", app.name);
//         return Promise.resolve();
//     },
//     afterMount: (app) => {
//         NProgress.done()
//         console.log("afterMount", app.name);
//         return Promise.resolve();
//     },
//     afterUnmount: (app) => {
//         console.log("afterUnmount", app);
//         return Promise.resolve();
//     },
// });

/**
 * 添加全局的未捕获异常处理器
 */
addGlobalUncaughtErrorHandler((event) => {
    const {msg} = event;
    // 加载失败时提示
    if (msg && msg.includes("died in status LOADING_SOURCE_CODE")) {
        ElMessage.error("子应用加载失败，请检查应用是否可运行");
    }
});

// export default start;
